import { tv } from '@costar-ui/cosmos';
import baseToggleButtonGroup from './theme/base-toggle-button-group.esm.js';
import nextToggleButtonGroup from './theme/next-toggle-button-group.esm.js';

var base = tv(baseToggleButtonGroup);
var next = tv(nextToggleButtonGroup);
var toggleButtonGroupStyles = {
  base: base,
  next: next
};

export { toggleButtonGroupStyles };
//# sourceMappingURL=toggle-button-group.styles.esm.js.map
